<template>
    <div class="notice-list-pages">
        <div class="mb-3 flex justify-end">
            <el-button type="primary" @click="handleNotice()">{{ $t('Message.Send_notice') }}</el-button>
        </div>
        <el-table
            :data="list"
            border
            style="width: 100%;
                margin-top: 20px">
            <el-table-column
                prop="createdAt"
                :label="$t('Common.time')">
            </el-table-column>
            <el-table-column
                prop="content"
                :label="$t('Setting.content')">
                <template slot-scope="{row}">
                    <div v-html="row.content"></div>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    :label="$t('Common.operating')"
                    width="100">
                <template slot-scope="scope">
                    <el-button
                        @click="handleClick(scope.row)"
                        type="text"
                        size="small"
                    >{{ $t('tooltip.check') }}</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            v-if="list && list.length"
            class="text-right mt-10"
            @current-change="fetchNotice"
            :current-page.sync="form.page"
            :page-size="form.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
        <!-- 弹窗 -->
        <notice-detail :item="currentRow" ref="noticeDetail"/>
        <send-notice ref="send" @fetchNotice="fetchNotice" />
    </div>
</template>

<script>
import NoticeDetail from '@/components/Dialog/Setting/NoticeDetail';
import SendNotice from '@/components/Dialog/Setting/SendNotice';

export default {
    name: 'notice-list',
    components: {
        NoticeDetail,
        SendNotice,
    },
    data() {
        return {
            list: [],
            form: {
                page: 1,
                size: 50,
            },
            pagination: {
                total: 0,
            },
            currentRow: null,
        };
    },
    async created() {
        await this.fetchNotice();
    },
    methods: {
        handleClick(row) {
            this.currentRow = row;
            this.$refs.noticeDetail.open(row);
        },
        fetchNotice() {
            API.get('notice/pages', {
                params: this.form,
            }).then((res) => {
                this.list = res.content;
                this.pagination.total = res.totalElements;
            });
        },
        handleNotice() {
            this.$refs.send.open();
        },
    },
};
</script>

<style lang="scss">
.notice-list-pages {
    p {
        margin: 0;
    }
}
</style>
